import { render, staticRenderFns } from "./activities-tables.vue?vue&type=template&id=30fdaa5c"
import script from "./activities-tables.vue?vue&type=script&lang=js"
export * from "./activities-tables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports